const MAIN_BUNDLE_PATTERN = /\/static\/js\/main(?:\.[^/]+)?\.js$/;

export default function getAssetBasePath() {
  const configuredBasePath =
    process.env.REACT_APP_BASE_URL || process.env.PUBLIC_URL;

  if (configuredBasePath) {
    return configuredBasePath.replace(/\/$/, "");
  }

  if (typeof document !== "undefined") {
    const scriptMatch = Array.from(document.scripts || []).find((script) =>
      MAIN_BUNDLE_PATTERN.test(script.src || "")
    );

    if (scriptMatch) {
      return scriptMatch.src.replace(MAIN_BUNDLE_PATTERN, "");
    }
  }

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return "";
}



// WEBPACK FOOTER //
// ./src/components/App/getAssetBasePath.js